import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconAccelerometerMiddleProps } from './IconAccelerometerMiddle.types'
import * as Styled from './styles/IconAccelerometerMiddle.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAccelerometerMiddle: FC<IconAccelerometerMiddleProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAccelerometerMiddleProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconAccelerometerMiddleProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M21.477 12.04c0 5.245-4.254 9.5-9.5 9.5-5.247 0-9.5-4.255-9.5-9.5 0-5.25 4.253-9.5 9.5-9.5h9.5Zm-2.043.046H17.98M6.727 6.79l1.03 1.026m9.481-1.026-1.027 1.026M4.55 12.04h1.458'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M12.535 12.04a.558.558 0 1 1-1.117 0 .558.558 0 0 1 1.117 0ZM12 4.578v7.453' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconAccelerometerMiddle
